<template>
  <Walkthrough 
    roomName="El Coche"
    roomKey="car"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="spanish"
  />
</template>
<script>

export default {
  name: 'Car',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/car-1920x1280.jpg",
      steps: [
        "Mira a la derecha y luego inspecciona el asiento. Deberías encontrar un destornillador.",
        "Mire hacia arriba y luego usa el destornillador en la lámpara. Después de desenroscar la lámpara deberás encontrar un cuchillo en el interior.",
        "Mira hacia abajo y usa tu cuchillo en el cinturón de seguridad. Esto debería liberarte y permitirte moverte libremente al frente del coche.",
        "Mira a la izquierda e inspecciona el portavasos. Parece que alguien cometió un error y te dejó una llave.",
        "Mira hacia adelante y luego usa tu destornillador en el panel de instrumentos. Esto debería quitar el panel de instrumentos y revelar un montón de cables.",
        "Todavía mirando hacia adelante, usa la llave en la guantera. Esto debería desbloquearla y deberías encontrar algunas cintas eléctricas y un mensaje en el manual.",
        " By using the message found in the manual, you know which cables not to use. Remember this. ",
        "Ahora que tienes los colores para conectar los cables eléctricos, usa la cinta eléctrica en los cables y conecta los cables verde, naranja, negro y azul. ¡El coche debería comenzar ahora a tener energía!",
        "Mira hacia abajo e inspecciona la alfombra. Observa que la matrícula que encontraste tiene números romanos 2145. ¡Este es el código para la caja fuerte!",
        "Mirando hacia adelante, ingresa el código 2415 en la caja fuerte y cuando se abra, deberás encontrar un martillo en el interior.",
        "¡Usa el martillo del parabrisas para romperlo y escapar a la libertad! ¡Intenta escapar de la siguiente habitación por tu cuenta!",
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/walkthrough/es/car.vue